const u = (e) => new Promise((t) => setTimeout(t, e)), c = () => {
};
function m(e) {
  try {
    JSON.parse(e);
  } catch {
    return !1;
  }
  return !0;
}
const o = (e) => {
  let t = 0;
  const a = async (n, r) => {
    let s;
    try {
      s = await e.fetch();
    } catch {
      return r(new Error(e.errorMessage));
    }
    if (t++, e.validate(s))
      return n(s);
    if (e.maxAttempts && t === e.maxAttempts)
      return r(new Error(e.errorMessage));
    setTimeout(a, e.interval, n, r);
  };
  return new Promise(a);
}, l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isJSON: m,
  noop: c,
  poll: o,
  sleep: u
}, Symbol.toStringTag, { value: "Module" }));
export {
  m as i,
  l as m,
  c as n,
  o as p,
  u as s
};
